module.exports = __webpack_public_path__ + "assets/img/32_616_big.3691e549.jpg";